<template>
    <section
        id="intro"
        class="bg-primary"
    >
        <!-- Call-to-action component that is only shown in mobile -->
        <div 
            id="cta"
            class="d-flex flex-column flex-sm-row d-lg-none justify-content-between align-items-center bg-white p-3 p-sm-4"
        >
            <h4 class="mb-2">
                {{ $t(`${$route.name}.intro.card1.title`) }}
            </h4>

            <b-btn :to="{name: `test${routePrefix}`}">
                {{ $t('common.buttons.linkTest') }}
            </b-btn>
        </div>
        
        <b-container class="pt-4 pt-md-5 pb-10">
            <b-row
                align-h="between"
                class="pb-4 pb-md-5"
            >
                <b-col
                    lg="5"
                    class="text-white"
                >
                    <b-row>
                        <b-col
                            cols="12"
                            sm="6"
                            lg="12"
                        >
                            <h4 class="mb-4">
                                {{ $t(`${$route.name}.intro.title`) }}
                            </h4>
                        </b-col>

                        <b-col
                            cols="12"
                            sm="6"
                            lg="12"
                        >
                            <!-- eslint-disable-next-line vue/no-v-html  -->
                            <p v-html="$t(`${$route.name}.intro.text`)" />
                        </b-col>
                    </b-row>
                </b-col>

                <b-col
                    lg="7"
                    xl="6"
                    class="d-none d-lg-block"
                    style="margin-top: -7rem;"
                >
                    <b-row
                        align-v="start"
                        align-h="between"
                        class="bg-white p-4"
                        no-gutters
                    >
                        <b-col xl="7">
                            <h4 class="mb-3">
                                {{ $t(`${$route.name}.intro.card1.title`) }}
                            </h4>
                        </b-col>

                        <b-col
                            xl="5"
                        >
                            <b-btn
                                :to="{name: `test${routePrefix}`}"
                                class="float-right"
                            >
                                {{ $t('common.buttons.linkTest') }}
                            </b-btn>
                        </b-col>
                    </b-row>

                    <b-row
                        align-v="end"
                        align-h="between"
                        class="border text-white p-4"
                        no-gutters
                    >
                        <b-col>
                            <h6 class="mb-3">
                                {{ $t(`${$route.name}.intro.card2.title`) }}
                            </h6>

                            <!-- eslint-disable vue/no-v-html  -->
                            <p
                                class="small pr-xl-3"
                                v-html="$t(`${$route.name}.intro.card2.text`)"
                            />
                            <!-- eslint-enable vue/no-v-html  -->
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>

export default {
    name: 'Intro',
    data() {
        return {
            routePrefix: undefined,
        };
    },
    watch: {
        $route: {
            handler: function() {
                this.routePrefix = this.$route.name.endsWith('Cancer') ? 'Cancer' : '';
            },
            immediate: true,
        },
    },
};
</script>
